import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export interface IScoreQuiz {
  score: number;
}

const getScoreQuiz = async (combId: string): Promise<IScoreQuiz | boolean> => {
  try {
    const config: AxiosRequestConfig = {
      method: "POST",
      // url: `https://quiz-back.firebird.rs/api/ultra/score-quiz`,
      
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/score-quiz`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/score-quiz`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        combId, // Slanje combination_id
      },
    };

    const response: AxiosResponse = await axios(config);
    const { data } = response.data;

    return data;
  } catch (error) {
    console.error("Došlo je do greške pri pozivu score-quiz API-ja:", error);
    return false;
  }
};

export default getScoreQuiz;
